import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { GsdSupportDialogComponent } from 'src/app/gsd-support-dialog/gsd-support-dialog.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  currentYear:number;
  isLoginPage: boolean = false;
  isUnAuthorizedPage: boolean = false;

  constructor(private dialog: MatDialog, private router: Router) {
    this.router.events.subscribe(() => {
      this.isLoginPage = this.router.url === '/login';
      this.isUnAuthorizedPage = this.router.url === '/unauthorized';
    });
  }

  ngOnInit() {
    this.currentYear = new Date().getFullYear();
  }

  openSupportDialog() {
    this.dialog.open(GsdSupportDialogComponent, {
      width: '400px',
      autoFocus: false,
      panelClass: 'custom-dialog-panel',
      position: {
        bottom: '90px',  // adjust based on your floating icon
        right: '80px'
      }
    });
  }
}
